export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_64_Email.becded5c.svg";